const SubTel = () => import('./SubTel.vue')
const PhoneWaiting = () => import('./PhoneWaitingNew.vue')
const LawyerWaiting = () => import('./LawyerWaiting.vue')
const Payment = () => import('./Payment.vue')
const UnLinkReason = () => import('./UnLinkReason.vue')
const UnLinkResearch = () => import('./UnLinkResearch.vue')
const PayWaiting = () => import('./PayWaiting.vue')
const PaySuccess = () => import('./PaySuccess.vue')
const LawyerEvaluation = () => import('./LawyerEvaluation.vue')

export {
  SubTel,
  PhoneWaiting,
  Payment,
  UnLinkReason,
  UnLinkResearch,
  LawyerWaiting,
  PayWaiting,
  PaySuccess,
  LawyerEvaluation,
}



// WEBPACK FOOTER //
// ./src/pages/telephone/index.js